$.fn.dateProgress = function() {
  this.each(function() {
    var $element = $(this);
    var total = $element.attr('data-total');
    var left = $element.attr('data-left');
    var progress = left * 100 / total;
    $element.find('span').css({
      'width': progress + '%'
    });
    if (progress > 0 && progress < 33.33) {
      $element.addClass('empty');
    }
    if (progress >= 33.33 && progress < 66.66) {
      $element.addClass('medium');
    }
    if (progress >= 66.66 && progress <= 100) {
      $element.addClass('full');
    }
  })
};

function init() {
  if ($('.card-file__date-bar').length > 0) {
    $('.card-file__date-bar').dateProgress();
  }
}
$(function() {
  init();
});